import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import {
  initHobbyPeopleSession,
  setHobbyGroupPhotoFlow,
} from "../../../redux/slices/uploadFlowSlice";
import {
  isAiSelfieCaricatureHobbyPostPaymentActive,
  resolveHobbyCaricatureRouteSlug,
  shouldUseHobbyCaricatureFlowForStoredAiSelfieArt,
} from "../../../services/stylePromptResolver";
import { resolveStationRouteSlug } from "../../../utils/stationFlowStorage";
import StationThemeLayout from "../../../layouts/StationThemeLayout";
import SignOutConfirmModal from "../../../modal/SignOutConfirmModal";

const SelectPeople = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { slug } = useParams();
  const dispatch = useDispatch();
  const [showGroupPhotoConfirm, setShowGroupPhotoConfirm] = useState(false);

  // Get selected station (child) first, then fall back to legacy stationData
  const stationData = useMemo(() => {
    const selectedRaw = localStorage.getItem("selectedStation");
    const fromSelected = selectedRaw ? JSON.parse(selectedRaw) : null;
    const fromStorage = JSON.parse(localStorage.getItem("stationData") || "{}");
    return fromSelected || fromStorage;
  }, [location.state]);

  const selectedArt = useMemo(() => {
    try {
      const fromNav = (
        location.state as {
          selectedArt?: {
            name?: string;
            inner_bg_image?: string | null;
            background_image?: string | null;
          };
        } | null
      )?.selectedArt;
      if (fromNav?.name) return fromNav;
      const raw = localStorage.getItem("selectedAiSelfieArt");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }, [location.state]);

  const aiSelfiePostPaymentHobby = isAiSelfieCaricatureHobbyPostPaymentActive();
  const caricatureHobbyByArt = shouldUseHobbyCaricatureFlowForStoredAiSelfieArt();
  const useHobbyCaricatureStationFlow =
    stationData?.type === "hobby-caricature" ||
    aiSelfiePostPaymentHobby ||
    caricatureHobbyByArt;

  const routeSlug = useHobbyCaricatureStationFlow
    ? resolveHobbyCaricatureRouteSlug(slug)
    : resolveStationRouteSlug(stationData, slug, selectedArt);

  const peopleOptions = [1, 2, 3, 4, 5, 6];

  const startIndividualPeopleFlow = (count: number) => {
    if (useHobbyCaricatureStationFlow) {
      dispatch(initHobbyPeopleSession(count));
      dispatch(setHobbyGroupPhotoFlow(false));
      navigate(`/${routeSlug}/select-media-library`);
      return;
    }

    navigate(`/${routeSlug}/select-media-library`);
  };

  /** Group Photo → confirm max 6 → choose option → extract people. */
  const startGroupPhotoFlow = () => {
    if (!useHobbyCaricatureStationFlow) return;
    setShowGroupPhotoConfirm(false);
    dispatch(setHobbyGroupPhotoFlow(true));
    navigate(`/${routeSlug}/select-media-library`, {
      state: { groupPhotoFlow: true },
    });
  };

  return (
    <>
      <StationThemeLayout
        className="chooseOptionSection p-0"
        station={stationData}
        showStationLogo
        onBack={() => navigate(`/${routeSlug}/idle`)}
      >
        <div className="selectPeopleSection">
          <div className="selectPeopleContent">
            <div className="selectPeopleNotice" role="note">
              <div className="selectPeopleNoticeHeading">ONE PERSON PER PHOTO</div>
              <div className="selectPeopleNoticeDescription text-center">
                {useHobbyCaricatureStationFlow ? (
                  <>
                    <div className="px-5">
                      Each photo should show only one person. Or choose Group Photo below to extract everyone from one image.
                    </div>
                  </>
                ) : (
                  <>
                    Each photo should show only one person. Do not take or select a group photo.
                  </>
                )}
              </div>
            </div>

            <div className="topHeading my-4">
              How Many <span>People</span> Are We <br /> Creating For?
            </div>

            <div className="peopleSection">
              {peopleOptions.map((item: number) => {
                return (
                  <button
                    type="button"
                    className="singleSection"
                    key={item}
                    onClick={() => startIndividualPeopleFlow(item)}
                  >
                    <span className="singleSectionNum">{item}</span>
                  </button>
                );
              })}
            </div>

            {/* {useHobbyCaricatureStationFlow ? (
              <>
                <div className="selectPeopleOrDivider my-4" aria-hidden="true">
                  <span className="selectPeopleOrLine" />
                  <span className="selectPeopleOrText">OR</span>
                  <span className="selectPeopleOrLine" />
                </div>

                <button
                  type="button"
                  className="groupPhotoOption"
                  onClick={() => setShowGroupPhotoConfirm(true)}
                >
                  Group Photo
                </button>
              </>
            ) : null} */}
          </div>
        </div>
      </StationThemeLayout>

      {/* Temporarily hide Group Photo confirm — keep for restore with the button above. */}
      {/* {showGroupPhotoConfirm && (
        <SignOutConfirmModal
          show={showGroupPhotoConfirm}
          className="groupPhotoConfirmModal"
          onHide={() => setShowGroupPhotoConfirm(false)}
          onConfirm={startGroupPhotoFlow}
          title="Please make sure your photo has no more than 6 people."
          message="You can continue to take or upload a group photo."
          confirmLabel="Continue"
          cancelLabel="Cancel"
        />
      )} */}
    </>
  );
};

export default SelectPeople;
